import * as t from './actionTypes';

const initialState = {
  invitations: {},
};

export const getInitialState = (customState = {}) => ({
  ...initialState,
  ...customState,
});

export const invitations = (state = initialState.invitations, action) => {
  switch (action.type) {
    case t.ADMIN_PEOPLE_INVITE_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};
